import { render, staticRenderFns } from "./AboutLink.vue?vue&type=template&id=5bd02a24&scoped=true&"
import script from "./AboutLink.vue?vue&type=script&lang=js&"
export * from "./AboutLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd02a24",
  null
  
)

export default component.exports